module.exports = __webpack_public_path__ + "website/img/serveImg01.7aed0817.png";